import * as React from "react"
const SvgLayout = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 18.997V5.003l.002-.001L5.003 5h3.994l.001.002.002.001v13.994l-.002.001-.001.002H5.003l-.001-.002zM15.003 19h3.994l.001-.002.002-.001v-4.993l-.002-.002-.001-.002h-3.994l-.001.002-.002.002v4.993l.002.001zM15 7.997V5.003l.002-.001.001-.002h3.994l.001.002.002.001v2.994l-.002.001-.001.002h-3.994l-.001-.002zM3.588 20.413Q4.175 20.999 5 21h4q.825 0 1.412-.587Q11 19.825 11 19V5q0-.824-.588-1.412A1.93 1.93 0 0 0 9 3H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 5v14q0 .824.587 1.413Zm10 0Q14.175 21 15 21h4q.824 0 1.413-.587A1.93 1.93 0 0 0 21 19v-5q0-.825-.587-1.412A1.93 1.93 0 0 0 19 12h-4q-.825 0-1.412.588A1.93 1.93 0 0 0 13 14v5q0 .824.588 1.413m0-11Q14.175 10 15 10h4q.824 0 1.413-.587Q20.999 8.824 21 8V5q0-.824-.587-1.412A1.93 1.93 0 0 0 19 3h-4q-.825 0-1.412.588A1.93 1.93 0 0 0 13 5v3q0 .824.588 1.413"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgLayout
